import { supabase } from "@/lib/supabaseClient";

/** 즐겨찾기 목록 조회 (word_id 배열) */
export async function getFavoriteIds(userId: string): Promise<string[]> {
  const { data, error } = await supabase.from("user_favorites").select("word_id").eq("user_id", userId);

  if (error) {
    throw error;
  }
  return data.map(row => row.word_id);
}

/** 즐겨찾기 토글 */
export async function toggleFavorite(userId: string, wordId: string): Promise<boolean> {
  // 이미 즐겨찾기인지 확인
  const { data: existing } = await supabase
    .from("user_favorites")
    .select("word_id")
    .eq("user_id", userId)
    .eq("word_id", wordId)
    .maybeSingle();

  if (existing) {
    // 제거
    const { error } = await supabase.from("user_favorites").delete().eq("user_id", userId).eq("word_id", wordId);

    if (error) {
      throw error;
    }
    return false; // 즐겨찾기 해제됨
  } else {
    // 추가
    const { error } = await supabase.from("user_favorites").insert({ user_id: userId, word_id: wordId });

    if (error) {
      throw error;
    }
    return true; // 즐겨찾기 추가됨
  }
}
